import { render } from "./Photo.vue?vue&type=template&id=64939286&scoped=true"
import script from "./Photo.vue?vue&type=script&lang=js"
export * from "./Photo.vue?vue&type=script&lang=js"

import "./Photo.vue?vue&type=style&index=0&id=64939286&lang=scss&scoped=true"

import exportComponent from "/Users/apple/Documents/xxiwant/lovestory/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64939286"]])

export default __exports__